import React from 'react'

import Flex from 'styled-flex-component'

import BillingHeaderTag from '@components/Billing/HeaderTag/HeaderTag'
import BillingHistorySideBar from '@components/Billing/SideBar/SideBar'
import BillingTitleBar from '@components/Billing/TitleBar/TitleBar'
import Purchase from '@components/Purchase/Purchase'
import MainLayout from '@components/UI/MainLayout'
import PaddedContainerStyled from '@components/UI/PaddedContainer/PaddedContainer.styled'
import Theme from '@theme'

const ContentLibraryPurchasesPage: React.FC = () => (
  <MainLayout backgroundColor={Theme.whiteColor}>
    <BillingHeaderTag />
    <BillingTitleBar />
    <Flex>
      <BillingHistorySideBar />
      <Flex column full>
        <PaddedContainerStyled>
          <Purchase />
        </PaddedContainerStyled>
      </Flex>
    </Flex>
  </MainLayout>
)

export default ContentLibraryPurchasesPage
